'use client';

import type {BundleBodyProps as Props} from './typings';

import Check from '@/components/icons-af/check';
import ProductImageLink from './ProductImageLink';
import ProductSummaryText from './ProductSummaryText';
import {
  StyledBundleCheckedList,
  StyledBundleImagesContainer,
  StyledProductBundleContent,
  StyledProductBundleParagraph,
  StyledText,
} from './styles';

const BundleBody = ({
  mainProduct,
  bundlePrice,
  bundleProduct,
  bundleDiscountAmount,
  currency,
  ctaAddButton,
  handleProductClick,
}: Props): JSX.Element => (
  <StyledProductBundleContent>
    <div>
      <StyledBundleImagesContainer>
        <ProductImageLink
          linkHref={`/product/${mainProduct.slug}`}
          linkTitle={`${mainProduct.name} by ${mainProduct.artist_name}`}
          imagePath={mainProduct.thumbor_images[0]?.path}
          imageAlt={mainProduct.name}
          handleClick={() => {
            handleProductClick(mainProduct.slug);
          }}
        />
        <span>+</span>
        <ProductImageLink
          linkHref={`/product/${bundleProduct.slug}`}
          linkTitle={`${bundleProduct.name} by ${bundleProduct.artist_name}`}
          imagePath={bundleProduct.thumbor_images[0]?.path}
          imageAlt={bundleProduct.name}
          handleClick={() => {
            handleProductClick(bundleProduct.slug);
          }}
        />
      </StyledBundleImagesContainer>
    </div>

    <div>
      <StyledProductBundleParagraph>
        Buy both artworks together: <StyledText $isArt>{bundlePrice}</StyledText>
      </StyledProductBundleParagraph>

      <StyledText as="p" $isRed>
        Saving of {bundleDiscountAmount}
      </StyledText>

      <StyledBundleCheckedList aria-label="Bundle products list">
        <li aria-label={mainProduct.name}>
          <Check />
          {`"${mainProduct.name}", `}
          <ProductSummaryText
            categoryName={mainProduct.category_full_name}
            artistName={mainProduct.artist_name}
            price={mainProduct.pricing[currency]?.price as string}
          />
        </li>
        <li aria-label={bundleProduct.name}>
          <Check />
          {`"${bundleProduct.name}", `}
          <ProductSummaryText
            categoryName={bundleProduct.category_full_name}
            artistName={bundleProduct.artist_name}
            price={bundleProduct.pricing[currency]?.price as string}
          />
        </li>
      </StyledBundleCheckedList>

      {ctaAddButton}
    </div>
  </StyledProductBundleContent>
);

export default BundleBody;
